import styles from "./page.module.css";
import PageContainer from "@/app/settings/container/PageContainer";
import StatsCard from "./components/StatsCard/StatsCard";
import Flex from "@/components/Flex/Flex";
import { formatValue } from "@/utils/formatUtils";
import Chart from "./components/Chart/Chart";
import Divider from "@/components/Divider/Divider";
import SummaryTable from "./components/SummaryTable/SummaryTable";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import InfoBanner from "@/components/InformationBanner/InfoBanner";
import { useProfitOverview } from "@/contexts/ProfitOverviewContext";
import ComparisonRangeSelector from "../profit-and-loss/components/ComparisonRangeSelector/ComparisonRangeSelector";


const Section = ({
  title,
  tooltipText,
  subFields1,
  subFields2,
  isRising1,
  isRising2
}) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeaderContainer}>
        <span className={styles.sectionHeader}>{title}</span>
        <Tooltip title={tooltipText}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.33331 11.334H8.66665V7.33398H7.33331V11.334ZM7.99998 6.00065C8.18887 6.00065 8.3472 5.93676 8.47498 5.80898C8.60276 5.68121 8.66665 5.52287 8.66665 5.33398C8.66665 5.1451 8.60276 4.98676 8.47498 4.85898C8.3472 4.73121 8.18887 4.66732 7.99998 4.66732C7.81109 4.66732 7.65276 4.73121 7.52498 4.85898C7.3972 4.98676 7.33331 5.1451 7.33331 5.33398C7.33331 5.52287 7.3972 5.68121 7.52498 5.80898C7.65276 5.93676 7.81109 6.00065 7.99998 6.00065ZM7.99998 14.6673C7.07776 14.6673 6.21109 14.4923 5.39998 14.1423C4.58887 13.7923 3.88331 13.3173 3.28331 12.7173C2.68331 12.1173 2.20831 11.4118 1.85831 10.6007C1.50831 9.78954 1.33331 8.92287 1.33331 8.00065C1.33331 7.07843 1.50831 6.21176 1.85831 5.40065C2.20831 4.58954 2.68331 3.88398 3.28331 3.28398C3.88331 2.68398 4.58887 2.20898 5.39998 1.85898C6.21109 1.50898 7.07776 1.33398 7.99998 1.33398C8.9222 1.33398 9.78887 1.50898 10.6 1.85898C11.4111 2.20898 12.1166 2.68398 12.7166 3.28398C13.3166 3.88398 13.7916 4.58954 14.1416 5.40065C14.4916 6.21176 14.6666 7.07843 14.6666 8.00065C14.6666 8.92287 14.4916 9.78954 14.1416 10.6007C13.7916 11.4118 13.3166 12.1173 12.7166 12.7173C12.1166 13.3173 11.4111 13.7923 10.6 14.1423C9.78887 14.4923 8.9222 14.6673 7.99998 14.6673ZM7.99998 13.334C9.48887 13.334 10.75 12.8173 11.7833 11.784C12.8166 10.7507 13.3333 9.48954 13.3333 8.00065C13.3333 6.51176 12.8166 5.25065 11.7833 4.21732C10.75 3.18398 9.48887 2.66732 7.99998 2.66732C6.51109 2.66732 5.24998 3.18398 4.21665 4.21732C3.18331 5.25065 2.66665 6.51176 2.66665 8.00065C2.66665 9.48954 3.18331 10.7507 4.21665 11.784C5.24998 12.8173 6.51109 13.334 7.99998 13.334Z"
            fill="var(--sentiment-text-info)"  
            />
          </svg>
        </Tooltip>
      </div>
      <Flex gap={2} style={{ height: "100%"}}>
        <StatsCard subFields={subFields1} isRising={isRising1} label={"Previous Period"}/>
        <StatsCard subFields={subFields2} isRising={isRising2} label={"Current Period"}/>
      </Flex>
    </div>
  )
}

const ChartSection = ({
  title,
  tooltipText,
  periodValue1,
  periodValue2,
  isRising1,
  isRising2,
  percentage1,
  percentage2
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.sectionHeaderContainer}>
        <span className={styles.sectionHeader}>{title}</span>
        <Tooltip title={tooltipText}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.33331 11.334H8.66665V7.33398H7.33331V11.334ZM7.99998 6.00065C8.18887 6.00065 8.3472 5.93676 8.47498 5.80898C8.60276 5.68121 8.66665 5.52287 8.66665 5.33398C8.66665 5.1451 8.60276 4.98676 8.47498 4.85898C8.3472 4.73121 8.18887 4.66732 7.99998 4.66732C7.81109 4.66732 7.65276 4.73121 7.52498 4.85898C7.3972 4.98676 7.33331 5.1451 7.33331 5.33398C7.33331 5.52287 7.3972 5.68121 7.52498 5.80898C7.65276 5.93676 7.81109 6.00065 7.99998 6.00065ZM7.99998 14.6673C7.07776 14.6673 6.21109 14.4923 5.39998 14.1423C4.58887 13.7923 3.88331 13.3173 3.28331 12.7173C2.68331 12.1173 2.20831 11.4118 1.85831 10.6007C1.50831 9.78954 1.33331 8.92287 1.33331 8.00065C1.33331 7.07843 1.50831 6.21176 1.85831 5.40065C2.20831 4.58954 2.68331 3.88398 3.28331 3.28398C3.88331 2.68398 4.58887 2.20898 5.39998 1.85898C6.21109 1.50898 7.07776 1.33398 7.99998 1.33398C8.9222 1.33398 9.78887 1.50898 10.6 1.85898C11.4111 2.20898 12.1166 2.68398 12.7166 3.28398C13.3166 3.88398 13.7916 4.58954 14.1416 5.40065C14.4916 6.21176 14.6666 7.07843 14.6666 8.00065C14.6666 8.92287 14.4916 9.78954 14.1416 10.6007C13.7916 11.4118 13.3166 12.1173 12.7166 12.7173C12.1166 13.3173 11.4111 13.7923 10.6 14.1423C9.78887 14.4923 8.9222 14.6673 7.99998 14.6673ZM7.99998 13.334C9.48887 13.334 10.75 12.8173 11.7833 11.784C12.8166 10.7507 13.3333 9.48954 13.3333 8.00065C13.3333 6.51176 12.8166 5.25065 11.7833 4.21732C10.75 3.18398 9.48887 2.66732 7.99998 2.66732C6.51109 2.66732 5.24998 3.18398 4.21665 4.21732C3.18331 5.25065 2.66665 6.51176 2.66665 8.00065C2.66665 9.48954 3.18331 10.7507 4.21665 11.784C5.24998 12.8173 6.51109 13.334 7.99998 13.334Z" fill="var(--sentiment-text-info)" />
          </svg>
        </Tooltip>
      </div>
      <Flex gap={2} justify="space-between" style={{ width: "100%"}}>
        <div className={`${styles.card} ${styles.miniStatsCard}`}>
          <span className={styles.subTitle}>Previous Period</span>
          <Flex align="center" gap={3} style={{ marginTop: "0.5rem" }}>
            <span className={styles.displayValue}>{formatValue(periodValue1)}</span>
            <div className={`${styles.percentageBadge} ${isRising1 ? styles.rising : styles.falling}`}>
              {isRising1 ? 
                <svg className={styles.percentageIcon} xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                  <mask id="mask0_4071_3651" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="14">
                  <rect x="0.333252" width="14" height="14" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_4071_3651)">
                  <path d="M2.31667 10.5L1.5 9.68333L5.81667 5.3375L8.15 7.67083L11.1833 4.66667H9.66667V3.5H13.1667V7H12V5.48333L8.15 9.33333L5.81667 7L2.31667 10.5Z" fill="#006718"/>
                </g>
              </svg> 
              : <svg className={styles.percentageIconFalling} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M9.33329 10.5V9.33333H10.85L7.81663 6.32917L5.48329 8.6625L1.16663 4.31667L1.98329 3.5L5.48329 7L7.81663 4.66667L11.6666 8.51667V7H12.8333V10.5H9.33329Z"/>
              </svg>}
              <span className={styles.percentageText}>
                {percentage1}%
              </span>
            </div>
          </Flex>
        </div>
        <div className={`${styles.card} ${styles.miniStatsCard}`}>
          <span className={styles.subTitle}>Current Period</span>
          <Flex align="center" gap={3} style={{ marginTop: "0.5rem" }}>
            <span className={styles.displayValue}>{formatValue(periodValue2)}</span>
            <div className={`${styles.percentageBadge} ${isRising2 ? styles.rising : styles.falling}`}>
              {isRising2 ? 
                <svg className={styles.percentageIcon} xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                  <mask id="mask0_4071_3651" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="14">
                  <rect x="0.333252" width="14" height="14" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_4071_3651)">
                  <path d="M2.31667 10.5L1.5 9.68333L5.81667 5.3375L8.15 7.67083L11.1833 4.66667H9.66667V3.5H13.1667V7H12V5.48333L8.15 9.33333L5.81667 7L2.31667 10.5Z" fill="#006718"/>
                </g>
              </svg> 
              : <svg className={styles.percentageIconFalling} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M9.33329 10.5V9.33333H10.85L7.81663 6.32917L5.48329 8.6625L1.16663 4.31667L1.98329 3.5L5.48329 7L7.81663 4.66667L11.6666 8.51667V7H12.8333V10.5H9.33329Z"/>
              </svg>}
              <span className={styles.percentageText}>
                {percentage2}%
              </span>
            </div>
          </Flex>
        </div>
      </Flex>
      <Chart />
      <Divider margin="1rem"/>
      <SummaryTable />
    </div>
  )
}

const ProfitOverviewPage = () => {
  const { currentPeriod, previousPeriod, setCurrentPeriod } = useProfitOverview();

  return (
    <PageContainer>
      <InfoBanner
        className={styles.infoBanner}
        message={"Use the “date picker” to select the dates you would like to compare your profits."}
        storageKey={"profitOverViewAlertBannerKey"}
      />
      <div className={styles.comparisionRange}>
        <ComparisonRangeSelector
          currentRange={currentPeriod}
          comparisonRange={previousPeriod} 
          onCurrentRangeChange={setCurrentPeriod}
        />
      </div>
      <div className={styles.metricContainer}>
        <Section title="Units Sold" tooltipText="Number of units you sold" 
          subFields1={[
            {
              label: "Units shippped",
              value: 35
            },
            {
              label: "Promo Units Sold",
              value: 10
            },
            {
              label: "Pending Units",
              value: 56
            }
          ]}
          subFields2={[
            {
              label: "Units shippped",
              value: 35
            },
            {
              label: "Promo Units Sold",
              value: 10
            },
            {
              label: "Pending Units",
              value: 56
            }
          ]}
          isRising1={false}
          isRising2={true}
        />
        <Section title="Revenue" tooltipText="Total revenue from units sold"
          subFields1={[
            {
              label: "Units shippped",
              value: 35
            },
            {
              label: "Promo Units Sold",
              value: 10
            },
            {
              label: "Pending Units",
              value: 56
            }
          ]}
          subFields2={[
            {
              label: "Units shippped",
              value: 35
            },
            {
              label: "Promo Units Sold",
              value: 10
            },
            {
              label: "Pending Units",
              value: 56
            }
          ]}
          isRising1={false}
          isRising2={true}
        />
        <Section title="ROI" tooltipText="Return on investment" 
          subFields1={[
            {
              label: "Units shippped",
              value: 35
            },
            {
              label: "Promo Units Sold",
              value: 10
            },
            {
              label: "Pending Units",
              value: 56
            }
          ]}
          subFields2={[
            {
              label: "Units shippped",
              value: 35
            },
            {
              label: "Promo Units Sold",
              value: 10
            },
            {
              label: "Pending Units",
              value: 56
            }
          ]}
          isRising1={false}
          isRising2={true}
        />
      </div>
      <div className={`${styles.grid}`}>
        <div className={styles.gridItem}>
            <ChartSection 
              title="Net Profit"
              tooltipText="Your net profit"
              periodValue1={16.87}
              periodValue2={36.78}
              isRising1={false} 
              isRising2={true} 
              percentage1={10} 
              percentage2={20}
            />
        </div>  
        <div className={styles.gridItem}>
            <ChartSection 
              title="Revenue"
              tooltipText="Total revenue from units sold"
              periodValue1={16.87}
              periodValue2={36.78}
              isRising1={false} 
              isRising2={true} 
              percentage1={10} 
              percentage2={20}
            />
        </div>
        <div className={styles.gridItem}>
            <ChartSection 
              title="Buy Cost"
              tooltipText="Your buy cost"
              periodValue1={16.87}
              periodValue2={36.78}
              isRising1={false} 
              isRising2={true} 
              percentage1={10} 
              percentage2={20}
            />
        </div>
        <div className={styles.gridItem}>
            <ChartSection 
              title="Units Sold"
              tooltipText="Your units sold"
              periodValue1={16.87}
              periodValue2={36.78}
              isRising1={false} 
              isRising2={true} 
              percentage1={10} 
              percentage2={20}
            />
        </div>
      </div>
    </PageContainer>
  );
};

export default ProfitOverviewPage